"use client";

import { CookiePreferences } from "@ethera/ui/consent";
import { PREFERENCES_COPY } from "@/components/public/cookie-consent";

export function CookiesContent() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-semibold text-foreground">Cookie preferences</h1>
      <p className="mt-4 text-muted-foreground">
        We use a single analytics vendor (PostHog) with your permission. Essential cookies keep you
        signed in and the site working — they cannot be switched off. Update your choices below at
        any time; your decision is recorded and re-confirmed after 12 months.
      </p>
      <div className="mt-8">
        <CookiePreferences copy={PREFERENCES_COPY} />
      </div>
    </section>
  );
}
